module.exports = __webpack_public_path__ + "static/scale-model-of-rourke-art-museum-in-fargo-north-dakota-bf619d63a6c620f02fdc40786afff0a6.png";